import React from 'react'
import cx from 'classnames'
import moment from 'moment'

import { Grid, Cell } from 'components/layout/grid'

import s from './Days.scss'


const Days = ({ days, year, month, selectedDates, backgrounds, gutter, onDayClick }) => {
  const firstWeekDay  = moment(`${month}.${year}`, 'MM.YYYY').startOf('month').weekday()
  const activeDate    = selectedDates[0] && (
    selectedDates[0].format('MM') === month
    && selectedDates[0].format('YYYY') === year
    && Number(selectedDates[0].format('DD'))
  )

  return (
    <Grid className={s.days} columns={7} gutter={gutter}>
      {
        Boolean(firstWeekDay) && (
          <Cell size={firstWeekDay} />
        )
      }
      {
        days.map((day) => {
          const formattedDay = moment(`${day}.${month}.${year}`, 'DD.MM.YYYY').format('DD.MM.YYYY')

          return (
            <Cell
              key={day}
              style={{ background: backgrounds[formattedDay] }}
              className={cx(s.day, {
                [s.activeDate]: (
                  day === activeDate
                  || selectedDates.some((day) => day.format('DD.MM.YYYY') === formattedDay)
                ),
              })}
              size={1}
              onClick={() => onDayClick(day)}
            >
              {day}
            </Cell>
          )
        })
      }
    </Grid>
  )
}


export default Days
